import React from "react";
import { ShieldCheck } from "lucide-react";

export default function Logo({ variant = "light", size = "md" }) {
  const isDark = variant === "dark"; // dark text on white
  const color = isDark ? "#0F1C2E" : "#FFFFFF";
  const accent = "#10B981";
  const fs = size === "sm" ? 18 : size === "lg" ? 28 : 22;

  return (
    <div className="flex items-center gap-2" data-testid="compliche-logo">
      <span
        className="flex items-center justify-center rounded-md"
        style={{ width: fs + 6, height: fs + 6, background: accent }}
      >
        <ShieldCheck size={fs - 6} strokeWidth={2.4} color="#0F1C2E" />
      </span>
      <span style={{ fontSize: fs, fontWeight: 800, color, letterSpacing: "-0.02em" }}>
        Compliche
      </span>
    </div>
  );
}
